function create_fullwidth_media_text_blocks() {
	jQuery('.wp-block-media-text.wide').each(function(index, el) {

		if (jQuery(el).parents('.full_width_media_text').length) {

		} else {
			jQuery(el).wrap('<div class="full_width_media_text"><div class="grid-container"></div></div>');
		}
		
		var entryContentWidth = jQuery('.entry-content').width();
		var marginLeft = (jQuery( window ).width() - entryContentWidth)/2;

		if(marginLeft < 1) {
			marginLeft = 0;
		}

		var topParentContainer = jQuery(el).parent('.grid-container').parent('.full_width_media_text');

		jQuery(topParentContainer).css('margin-left', -marginLeft + 'px');

		var classList = jQuery(el).attr("class").split(' ');

		jQuery.each(classList, function(index, val) {
			 if(val.indexOf('background-color') >= 0) {
				jQuery(topParentContainer).addClass(val);
			}
		});


	});
}

function add_aos_to_media_text_block() {
	
	jQuery('.wp-block-media-text.wide').each(function(index, el) {

		if(jQuery(el).hasClass('has-media-on-the-right')) {

			var media = jQuery(el).find('.wp-block-media-text__media');
			var text = jQuery(el).find('.wp-block-media-text__content');
			jQuery(media).attr('data-aos', 'fade-left');
			jQuery(text).attr('data-aos', 'fade-right');

		} else {

			var media = jQuery(el).find('.wp-block-media-text__media');
			var text = jQuery(el).find('.wp-block-media-text__content');
			jQuery(media).attr('data-aos', 'fade-right');
			jQuery(text).attr('data-aos', 'fade-left');

		}

	});

	AOS.init();

}



jQuery(document).ready(function($) {

	add_aos_to_media_text_block();
	create_fullwidth_media_text_blocks();
	jQuery(window).resize(function(event) {
		create_fullwidth_media_text_blocks();
	});
	
});